import React from "react";
import PropTypes from "prop-types";
import { TableRow, Tooltip } from "@mui/material";
import { Typography, TextField } from "@totalsoft/rocket-ui";
import { TableCellWithWidth } from "components/list/TableComponentsStyled";

export const BalanceSheetDetailsIndicatorsRowComponent = ({ item }) => {
  return (
    <TableRow>
      <TableCellWithWidth w={30}>
        <Typography variant="body1">{item.orderNo}</Typography>
      </TableCellWithWidth>
      <TableCellWithWidth w={40}>
        <Typography variant="body1">{item.name}</Typography>
      </TableCellWithWidth>
      <TableCellWithWidth w={30}>
        <Tooltip title={item.expression}>
          <TextField
          isNumeric
          decimalScale={4}
          value={item.indicatorValue}
          disabled={true}
        />
        </Tooltip>
      </TableCellWithWidth>
    </TableRow>
  );
};

BalanceSheetDetailsIndicatorsRowComponent.propTypes = {
  item: PropTypes.object.isRequired
};

export default React.memo(BalanceSheetDetailsIndicatorsRowComponent);
